import type React from "react";
import { useContext, useEffect } from "react";

import AppMenu from "./AppMenu";
import { LayoutContext } from "./context/layoutcontext";
import { MenuProvider } from "./context/menucontext";
import { classNames } from "primereact/utils";

import { COCHARGE_DARK_GREEN } from "../styles/theme_constants";
import CochargeLogo from "../components/CochargeLogo";
import { isTestEnvironment } from "../utils/environment";

const TestEnvBadge = () => {
  if (!isTestEnvironment) return null;
  return (
    <div style={{ backgroundColor: COCHARGE_DARK_GREEN, padding: "0.4rem 1rem 0.6rem", textAlign: "center" }}>
      <span
        style={{
          background: "#f39c12",
          color: "#fff",
          fontWeight: 700,
          fontSize: "0.95rem",
          letterSpacing: "0.1em",
          padding: "0.3rem 1.2rem",
          borderRadius: "4px",
          textTransform: "uppercase",
        }}
      >
        TEST
      </span>
    </div>
  );
};

const AppSidebar = (props: { sidebarRef: React.RefObject<HTMLDivElement> }) => {
  const { setLayoutState, layoutState } = useContext(LayoutContext);

  const anchor = () => {
    setLayoutState((prevLayoutState) => ({
      ...prevLayoutState,
      anchored: !prevLayoutState.anchored,
    }));
  };

  useEffect(() => {
    return () => {
      resetOverlay();
    };
  });

  const resetOverlay = () => {
    if (layoutState.overlayMenuActive) {
      setLayoutState((prevLayoutState) => ({
        ...prevLayoutState,
        overlayMenuActive: false,
      }));
    }
  };

  return (
    <>
      <div ref={props.sidebarRef} className="layout-sidebar">
        <div
          className="sidebar-header"
          style={{ backgroundColor: COCHARGE_DARK_GREEN }}
        >
          <div className="py-2 -mb-4 px-3 flex flex-row justify-content-center align-items-center">
            <CochargeLogo />
          </div>
          <button
            className={classNames(
              "layout-sidebar-anchor p-link",
              { "border-900": layoutState.anchored },
              { "border-200": !layoutState.anchored }
            )}
            type="button"
            onClick={anchor}
          ></button>
        </div>
        <TestEnvBadge />
        <div
          className="layout-menu-container"
          style={{ backgroundColor: COCHARGE_DARK_GREEN }}
        >
          <MenuProvider>
            <AppMenu />
          </MenuProvider>
        </div>
        <div
          style={{
            backgroundColor: COCHARGE_DARK_GREEN,
            color: "rgba(255,255,255,0.4)",
            fontSize: "0.7rem",
            padding: "0.5rem 1rem",
            textAlign: "center",
          }}
        >
          {process.env.REACT_APP_BUILD_TIMESTAMP
            ? `Build: ${process.env.REACT_APP_BUILD_TIMESTAMP}`
            : "dev"}
        </div>
      </div>
    </>
  );
};

export default AppSidebar;
